import "bootstrap-icons/font/bootstrap-icons.css";
import React, { useState, useEffect } from "react";
import { Button, ButtonGroup } from "react-bootstrap";
import axios from "axios";
import InstructionModal from "./InstructionModal";
import { getNewCountry } from "../utils/util.js";
import CapitalsGameHard from "./CapitalsGameHard.jsx";
import CapitalsGameEasy from "./CapitalsGameEasy.jsx";

export default function Capitals() {
  const [hardGameInProgress, setHardGameInProgress] = useState(false);
  const [easyGameInProgress, setEasyGameInProgress] = useState(false);
  const [showInstructions, setShowInstructions] = useState(false);
  const usedCountry = new Map();
  const [easyHighScore, setEasyHighScore] = useState(0);
  const [hardHighScore, setHardHighScore] = useState(0);
  const startingCountry = getNewCountry(usedCountry);

  const exitHandler = () => {
    easyGameInProgress
      ? setEasyGameInProgress(false)
      : setHardGameInProgress(false);
  };

  useEffect(() => {
    const getHighScore = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/getCapitalsGameHighScore`
        );
        setEasyHighScore(response.data.easyHighScore.score);
        setHardHighScore(response.data.hardHighScore.score);
      } catch (err) {
        console.error("Failed to fetch high scores:", err);
      }
    };
    getHighScore();
  }, [easyGameInProgress, hardGameInProgress]);

  return (
    <div className="d-flex justify-content-center align-items-center full-height-minus-navbar bg-light">
      <div className="container p-4 rounded shadow-lg bg-white">
        <div className="text-center mb-4">
          <h1 className="display-4">
            Capitals Game{" "}
            <Button
              variant="link"
              size="lg"
              className="p-0"
              title="Click for instructions"
              onClick={() => setShowInstructions(true)}
            >
              <i className="bi bi-info-circle"></i>
            </Button>
          </h1>
        </div>
        <h5>Select a difficulty level:</h5>
        <div className="d-flex mb-4">
          <ButtonGroup>
            <Button
              variant={easyGameInProgress ? "primary" : "outline-primary"}
              size="lg"
              onClick={() => setEasyGameInProgress(true)}
              disabled={easyGameInProgress || hardGameInProgress}
            >
              Easy
            </Button>
            <Button
              variant={hardGameInProgress ? "danger" : "outline-danger"}
              size="lg"
              onClick={() => setHardGameInProgress(true)}
              disabled={easyGameInProgress || hardGameInProgress}
            >
              Hard
            </Button>
          </ButtonGroup>
          {(easyGameInProgress || hardGameInProgress) && (
            <Button
              className="ms-auto"
              variant="outline-danger"
              size="lg"
              onClick={exitHandler}
            >
              Quit
            </Button>
          )}
        </div>

        <InstructionModal
          show={showInstructions}
          handleClose={() => setShowInstructions(false)}
        />
        <div className="mt-4">
          {hardGameInProgress && (
            <CapitalsGameHard
              hardGameInProgress={hardGameInProgress}
              setHardGameInProgress={setHardGameInProgress}
              hardHighScore={hardHighScore}
              usedCountry={usedCountry}
              startingCountry={startingCountry}
            />
          )}
          {easyGameInProgress && (
            <CapitalsGameEasy
              easyGameInProgress={easyGameInProgress}
              setEasyGameInProgress={setEasyGameInProgress}
              easyHighScore={easyHighScore}
              usedCountry={usedCountry}
              startingCountry={startingCountry}
            />
          )}
        </div>
      </div>
    </div>
  );
}
